var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('content-card',{attrs:{"title":"Archiv Alle MA","cardIcon":"fas fa-archive"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('vacation-table',{attrs:{"pageSection":"ExecutiveArchive"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }